import React from "react";
import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";
import loadingSpiner from "../../public/img/home/loading.gif";



const LoaderSpin = ({ isVisible, isLoading }) => {
  if (isVisible) {
    return (
      <img
        src={loadingSpiner}
        alt="loading spinner"
        style={{
          height: "40px",
          width: "40px",
          radius: "2px",
          marginTop: "25px",
          marginBottom: "25px",
        }}
      />
     
    );
  } else {
    return null;
  }
};
export default LoaderSpin;
